import { ThemeDescriptor } from '../model/theme';
import * as t from 'io-ts';
import Color from 'color';

export const ThemeClassicCodec = t.type({
    type: t.literal('classic'),
    accent: t.string
});
export type ThemeClassic = t.TypeOf<typeof ThemeClassicCodec>;
export const ThemeClassicDescriptor: ThemeDescriptor<ThemeClassic> = {
    key: 'classic',
    name: 'Classic',
    default: {
        type: 'classic',
        accent: '#2F80ED'
    },
    resolve: (src) => {
        return {
            accent: src.accent,
            accentText: Color(src.accent).isDark()? '#fff' : '#ddd',
            accentIconTint: '#000',

            primary: '#000',
            primaryText: '#000',

            background: '#fff',
            backgroundText: '#000',

            secondary: '#fff',
            secondaryText: '#000',
            separator: '#eee',

            iconTint: '#000',

            bottomNavigationIcon: '#000',
            bottomNavigationText: '#000',
            bottomNavigationAccent: src.accent,
            bottomNavigationBackground: '#F2F2F2',
            bottomNavigationInactiveIcon: '#9b9b9b',
            bottomNavigationInactiveText: '#9b9b9b',

            toolBarText: '#000',
            toolBarIcon: '#9b9b9b',
            toolBarAccent: src.accent,
            toolBarBackground: '#F2F2F2',

            priceBackground: '#db7a7a',
            priceOldText: '#DDD',
            priceText: '#61aca9',

            toCartBackground: src.accent,
            toCartIconTint: Color(src.accent).isDark()? '#fff' : '#ddd',
            toCartText: Color(src.accent).isDark()? '#fff' : '#ddd',
        };
    }
}